// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"building-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6.49991 4C8.99995 4.00003 9.16656 6.66667 8.99991 8L9.00049 11H21.0005V21H4.00044V8C3.83378 6.66667 3.99981 4 6.49991 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M13 16V21H17V16H13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M13 16H17V21H13z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2.5 8H3.99991M3.99991 8H8.99991M3.99991 8V21H8.99991M3.99991 8C3.83324 6.66667 3.99981 4 6.49991 4M8.99991 8H10.5M8.99991 8V21M8.99991 8C9.16657 6.66667 9 4 6.49991 4M8.99991 21H21V11H9L8.99991 21ZM6.49991 4V2.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-building-1')
export default class Building1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-1',
    }
  }
}
